// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fh-0";
export var fileCarousel = "_fh-2";
export var removeFileButton = "_fh-1";